import React, { Component } from "react";
import { Row, Col, message } from "antd";
import { FormattedMessage } from "react-intl";
import { LEAD_INFO_BY_ID } from "./gql/query";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";
import moment from "moment";
import ru from "moment/locale/ru";
import momentDurationFormat from "moment-duration-format";

import URL from "../../utils/url";
import { Svg } from "../../utils/Svg";
import { Loading } from "../../utils/loading";
import copy from "../../utils/copyClipboard";
import { getLeadQuality } from "./utils";
import CustomerJourney from "./CustomerJourney";

const rowsWithCapitalLetter = ['os', 'browser']

// Lead information table;
class Lead extends Component {
  _onCopy = (e, value) => {
    e.stopPropagation();
    copy(value);
    message.success(
      this.props.intl.formatMessage({
        id: "analytics.copied",
        defaultMessage: "Copied"
      }),
      1
    );
  };
  /**
   * Render row
   * @param {defaultMsg{string}, value{string|jsx}, title{string}}, _key{integer}
   * @return {JSX}
   * @private
   */
  _tableRow = ({ defaultMsg, value, title, isFullRow = false }, _key) => (
    <Row className="lead-information__row" type="flex" key={_key}>
      <Col
        className="lead-information__row-title"
        xs={title === "id" ? 3 : 13}
        md={isFullRow ? 6 : title === "id" ? 3 : 13}
      >
        <FormattedMessage
          id={"analytics.lead." + title}
          defaultMessage={defaultMsg}
          description="Lead information row"
        />
      </Col>
      {title === "id" ? (
        <Col
          className="lead-information__row-value"
          xs={21}
          md={21}
          style={{
            cursor: "pointer",
            display: "flex",
            justifyContent: "flex-end"
          }}
          onClick={e => this._onCopy(e, value)}
        >
          <span>{value}</span>
          <span style={{ padding: "0 10px" }}>
            <Svg id="copy" />
          </span>
        </Col>
      ) : (
        <Col
          className="lead-information__row-value"
          xs={10}
          md={isFullRow ? 18 : 11}
        >
          <span style={rowsWithCapitalLetter.includes(title)? {textTransform: 'capitalize'}: null}>{value}</span>
        </Col>
      )}
    </Row>
  );

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { loading, lead } = this.props.data;
    const days = formatMessage({
      id: "analytics.days",
      defaultMessage: "d"
    });
    const unknownMsg = formatMessage({
      id: "analytics.unknown",
      defaultMessage: "Unknown"
    });
    return (
      <div className="lead-information">
        <Row className="lead-information__content" type="flex">
          <Col className="lead-information__column" sm={24} xs={24} md={12}>
            <h2>
              <FormattedMessage
                id="analytics.lead.header.general"
                defaultMessage="General information"
                description="Lead information header"
              />
            </h2>
            <div className="lead-information__table">
              {loading ? (
                <div style={{ minHeight: "180px" }}>
                  <Loading />
                </div>
              ) : (
                [
                  { defaultMsg: "#", value: lead.id, title: "id" },
                  {
                    defaultMsg: "Date and time",
                    value:
                      moment.utc(lead.submitTime).format("DD.MM.YYYY HH:mm") ||
                      unknownMsg,
                    title: "date"
                  },
                  {
                    defaultMsg: "Completed/ Not completed",
                    value: lead.submitTime
                      ? formatMessage({
                          id: "analytics.completed",
                          defaultMessage: "Completed"
                        })
                      : formatMessage({
                          id: "analytics.notCompleted",
                          defaultMessage: "Not completed"
                        }),
                    title: "completed"
                  },
                  {
                    defaultMsg: "Campaign",
                    value: lead.pixel.project.title,
                    title: "campaign"
                  },
                  {
                    defaultMsg: "Creative",
                    value: lead.pixel.title,
                    title: "creative"
                  }
                ].map((item, i) => this._tableRow(item, i))
              )}
            </div>
            <h2>
              <FormattedMessage
                id="analytics.lead.header.device"
                defaultMessage="Device information"
                description="Lead information header"
              />
            </h2>
            <div className="lead-information__table">
              {loading ? (
                <div style={{ minHeight: "210px" }}>
                  <Loading />
                </div>
              ) : (
                [
                  {
                    defaultMsg: "Desktop/ mobile",
                    value:
                      (lead.deviceModel && lead.deviceModel.deviceType.name) ||
                      unknownMsg,
                    title: "mobile"
                  },
                  {
                    defaultMsg: "Device name",
                    value:
                      (lead.deviceModel &&
                        `${lead.deviceModel.brand.name} ${
                          lead.deviceModel.model
                        }`) ||
                      unknownMsg,
                    title: "device"
                  },
                  {
                    defaultMsg: "IP",
                    value: lead.ipAddr || unknownMsg,
                    title: "ip"
                  },
                  {
                    defaultMsg: "OS",
                    value:
                      (lead.osVersion && lead.osVersion.name) || unknownMsg,
                    title: "os"
                  },
                  {
                    defaultMsg: "Screen resolution",
                    value:
                      (lead.screen && (
                        lead.screen.width +
                          "x" +
                          lead.screen.height)) ||
                      unknownMsg,
                    title: "resolution"
                  },
                  {
                    defaultMsg: "Browser",
                    value:
                      (lead.browser && lead.browser.family.name) || unknownMsg,
                    title: "browser"
                  }
                ].map((item, i) => this._tableRow(item, i))
              )}
            </div>
          </Col>
          <Col className="lead-information__column" sm={24} xs={24} md={12}>
            <h2>
              <FormattedMessage
                id="analytics.lead.header.audit"
                defaultMessage="Audit"
                description="Lead information header"
              />
            </h2>
            <div className="lead-information__table">
              {loading ? (
                <div style={{ minHeight: "340px" }}>
                  <Loading />
                </div>
              ) : (
                [
                  {
                    defaultMsg: "Source",
                    value:
                      (lead.trafficChannel && lead.trafficChannel.name) ||
                      unknownMsg,
                    title: "source"
                  },
                  {
                    defaultMsg: "Authentic/ Not authentic",
                    value: lead.isAuthentic
                      ? formatMessage({
                          id: "analytics.authentic",
                          defaultMessage: "Authentic"
                        })
                      : formatMessage({
                          id: "analytics.notAuthentic",
                          defaultMessage: "Not authentic"
                        }),
                    title: "authentic"
                  },
                  {
                    defaultMsg: "Lead duration",
                    value:
                      (lead.metrikLeadDuration &&
                        moment
                          .utc(lead.metrikLeadDuration * 1000)
                          .format("HH:mm:ss")) ||
                      unknownMsg,
                    title: "duration"
                  },
                  {
                    defaultMsg: "Lead age",
                    value:
                      moment
                        .duration(lead.metrikLeadAge * 1000)
                        .format(`D[${days}]  HH:mm:ss`, { trim: false }) ||
                      unknownMsg,
                    title: "age"
                  },
                  {
                    defaultMsg: "Lead frequency",
                    value: lead.frequency,
                    title: "frequency"
                  },
                  {
                    defaultMsg: "Lead duplication",
                    value: lead.duplication
                      ? lead.duplication
                      : formatMessage({
                          id: "analytics.no",
                          defaultMessage: "No"
                        }),
                    title: "duplication"
                  },
                  {
                    defaultMsg: "Customer frequency",
                    value: lead.customerFrequency,
                    title: "CustomerFrequency"
                  },
                  {
                    defaultMsg: "IP Frequency",
                    value: lead.ipFrequency,
                    title: "ipFrequency"
                  },
                  {
                    defaultMsg: "Total entities",
                    value: lead.totalEntities,
                    title: "entities"
                  },
                  {
                    defaultMsg: "Total hops",
                    value: lead.totalHops,
                    title: "hops"
                  },
                  {
                    defaultMsg: "Closure",
                    value:
                      lead.feedbackResult === true
                        ? formatMessage({
                            id: "analytics.lead.Closed",
                            defaultMessage: "Closed"
                          }) +
                          " " +
                          moment.utc(lead.feedbackTime).format(
                            formatMessage({
                              id: "general.date-format",
                              defaultMessage: "YYYY-MM-DD"
                            })
                          )
                        : lead.feedbackResult === null
                          ? "NA"
                          : formatMessage({
                              id: "analytics.no",
                              defaultMessage: "No"
                            }),
                    title: "Closure"
                  },
                  {
                    defaultMsg: "Quality",
                    value: formatMessage({
                      id: `analytics.quality.${getLeadQuality(lead.score)}`,
                      defaultMessage: "NA"
                    }),
                    title: "Quality"
                  }
                ].map((item, i) => this._tableRow(item, i))
              )}
            </div>
            <h2>
              <FormattedMessage
                id="analytics.lead.header.affiliate"
                defaultMessage="Affiliate information"
                description="Lead information header"
              />
            </h2>
            <div className="lead-information__table">
              {loading ? (
                <div style={{ minHeight: "90px" }}>
                  <Loading />
                </div>
              ) : (
                [
                  {
                    defaultMsg: "Affiliate network",
                    value:
                      (lead.affiliateNetwork &&
                        lead.affiliateNetwork.nameRus) ||
                      unknownMsg,
                    title: "network"
                  },
                  {
                    defaultMsg: "Affiliate",
                    value:
                      (lead.affiliateNetwork &&
                        lead.affiliateNetwork.nameRus) ||
                      unknownMsg,
                    title: "Affiliate"
                  }
                ].map((item, i) => this._tableRow(item, i))
              )}
            </div>
          </Col>
        </Row>

        <Row className="lead-information__content" type="flex">
          <Col className="lead-information__column" sm={24} xs={24} md={24}>
            <h2>
              <FormattedMessage
                id="analytics.lead.header.URL"
                defaultMessage="URL"
                description="Lead information header"
              />
            </h2>
            <div className="lead-information__table">
              {loading ? (
                <div style={{ minHeight: "110px" }}>
                  <Loading />
                </div>
              ) : (
                [
                  {
                    defaultMsg: "ISP",
                    value:
                      (lead.provider && lead.provider.asnDescription) ||
                      unknownMsg,
                    title: "isp",
                    isFullRow: true
                  },
                  {
                    defaultMsg: "Location",
                    value: lead.geoInfo || unknownMsg,
                    title: "location",
                    isFullRow: true
                  },
                  {
                    defaultMsg: "URL",
                    value: (
                      <a href={(lead.location) || "#"}>
                        {(lead.location) || unknownMsg}
                      </a>
                    ),
                    title: "URL",
                    isFullRow: true
                  },
                  {
                    defaultMsg: "Referer",
                    value: (
                      <a href={(lead.referrer) || "#"}>
                        {(lead.referrer) || unknownMsg}
                      </a>
                    ),
                    title: "referer",
                    isFullRow: true
                  }
                ].map((item, i) => this._tableRow(item, i))
              )}
            </div>
          </Col>
        </Row>
        <Row className="lead-information__content" justify="space-between" type="flex">
          <Col className="lead-information__column" sm={24} md={24} >
            <CustomerJourney id={URL.parseUrlParams(this.props.location.search).id}/>
          </Col>
        </Row>
      </div>
    );
  }
}

export default graphql(LEAD_INFO_BY_ID, {
  options: ({ location }) => ({
    variables: { id: URL.parseUrlParams(location.search).id }
  })
})(injectIntl(Lead));



// WEBPACK FOOTER //
// ./src/components/dashboard/analytics/lead-information.js